export function toRoman(value) {
    const number = parseInt(value);
    const roman_mapping = {
        1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V', 6: 'VI', 7: 'VII', 8: 'VIII', 9: 'IX', 10: 'X'
    };
    if(value == 11) {
        return roman_mapping[number - 1]
    }

    return roman_mapping[number];
}

export function toEraString(era) {
    if(era == "detente") {
        return gettext("Détente");
    } else if (era == "postwar") {
        return gettext("Post War");
    } else {
        return gettext("Escalation");
    }
    return;
}
export function createMarkup(text) {
    return {__html: text}
}